// extracted by mini-css-extract-plugin
module.exports = {"tancarFlotant":"videoBase_tancarFlotant__NZDci","show":"videoBase_show__RO0mM","botoTancar":"videoBase_botoTancar__Xp8EN"};